<template>
  <div v-if="editMode || dgRowInEditMode[gridId + '.' + rowKey]">
    <div
      class="data-grid__lookUpWrapper"
      :class="{ _hasAddVal: controlInfo.ableToAddLookUpVal && !controlInfo.readonly }"
    >
      <multiselect
        v-model="selectedLookUp"
        :options="lookups"
        track-by="value"
        label="text"
        selectedLabel
        :searchable="true"
        selectLabel=""
        tagPlaceholder=""
        placeholder=""
        deselectLabel=""
        :allow-empty="false"
        @select="save"
        :disabled="controlInfo.readonly"
        openDirection="bottom"
        ref="select"
        @open="adjustDropdown"
        @close="releaseDropdown"
      />
      <a
        href="#"
        v-if="controlInfo.ableToAddLookUpVal && !controlInfo.readonly"
        class="data-grid__lookupAddVal"
        @click.prevent="showLookUpModal"
      >
        <icon name="plus" />
      </a>
    </div>
  </div>
  <div v-else>
    <div>
      <b-badge
        v-if="cellDisplayVal"
        href="#"
        pill
        variant="primary"
        @click.prevent="openLookUpRow"
      >{{ cellDisplayVal }}</b-badge>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { find, debounce } from 'lodash'
// services
import db from '@/services/db'
export default {
  props: [
    'rowKey',
    'cellKey',
    'cellVal',
    'cellDisplayVal',
    'options',
    'editMode',
    'gridId',
    'controlInfo',
  ],
  data() {
    return {
      selectedLookUp: { value: null, text: 'BLANK' },
      debounced: null
    }
  },
  watch: {
    cellVal() {
      this.setLookUpVal()
    },
    lookups() {
      this.setLookUpVal()
    }
  },
  computed: {
    ...mapState(['dataGrid_options', 'dgRowInEditMode']),
    lookUpTable() {
      return this.options.meta[this.cellKey].lookUpTable
    },
    lookUpTableDisplayColumn() {
      return this.dataGrid_options[this.lookUpTable].displayColumn
    },
    lookups() {
      const lookups = [{ value: null, text: 'BLANK' }]
      const lookUpTableVals = $getGrid && $getGrid(this.lookUpTable)

      if (lookUpTableVals) {
        lookUpTableVals.map(row => {
          lookups.push({
            text: row[this.lookUpTableDisplayColumn],
            value: row.rowKey,
          })
        })
      }

      return lookups
    },
  },
  methods: {
    setLookUpVal() {
      if (this.debounced) {
        this.debounced()
        return
      } else {
        this.debounced = debounce(() => {
          if (this.cellVal) this.selectedLookUp = find(this.lookups, { value: this.cellVal })
          else this.selectedLookUp = { value: null, text: 'BLANK' }
        }, 500)
      }

      this.debounced()
    },
    save() {
      this.$nextTick(() => {
        const data = {
          options: this.options,
          rowKey: this.rowKey,
          cellKey: this.cellKey,
          value: this.selectedLookUp.value,
        }

        if (this.options.isReactive || typeof this.options.isReactive === 'undefined') {
          db.dataGrid.data.saveCellVal(data)
        } else {
          const rowInst = this.$instByClass(this, 'data-grid__row')

          rowInst.rowData[this.cellKey] = this.selectedLookUp.value
        }
      })
    },
    showLookUpModal() {
      $dgAddRow(this.lookUpTable).then(rowKey => {
        $dgShowEditRowModal(this.lookUpTable, rowKey)
        this.selectedLookUp = { text: '', value: rowKey }
        this.save()
      })
    },
    openLookUpRow() {
      $dgShowEditRowModal(this.lookUpTable, this.cellVal)
    },
    adjustDropdown() {
      this.$multiselect_adjustDropdown.bind(this)()
    },
    releaseDropdown() {
      this.$multiselect_releaseDropdown.bind(this)()
    },
  },
  created() {
    this.$nextTick(() => {
      this.setLookUpVal()
    })
  },
  beforeDestroy() {
    this.selectedLookUp = null
    this.debounced = null
  }
}
</script>

<style lang="scss">
.data-grid .data-grid {
  &__cell._lookup {
    min-width: 250px;
    padding: 0;
  }
}
.data-grid {
  &__lookUpWrapper {
    &._hasAddVal {
      position: relative;
      padding-right: 40px;
      .data-grid__lookupAddVal {
        position: absolute;
        right: 10px;
        bottom: 11px;
      }
    }
  }
}
</style>
